import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from '@mc/i18n'
import { useStaticData } from '@mc/static-data-react'
import Rate from './Rate'

type RatingsProps = {
  onRate: (rating: number, currentRating: number) => void
  userRating?: number
  stars?: number
}

const Ratings = ({ onRate, userRating, stars = 5 }: RatingsProps) => {
  const { article } = useStaticData<{
    article: { average: string; ratingsCount: number }
  }>()
  const { t } = useTranslation('@mc/next')
  const [hoverCount, setHoverCount] = useState(0)
  const [currentRating, setCurrentRating] = useState(Number(article.average))
  const [articleRatingsCount, setArticleRatingsCount] = useState(
    article.ratingsCount,
  )

  const onClick = useCallback(
    (rating: number) => {
      onRate(rating, currentRating)
      setCurrentRating(rating)
      if (!userRating) {
        setArticleRatingsCount(articleRatingsCount + 1)
      }
    },
    [onRate, currentRating, articleRatingsCount, userRating],
  )

  const onMouseEnter = (index: number) => () => {
    setHoverCount(index + 1)
  }

  const onMouseLeave = () => {
    setHoverCount(0)
  }

  useEffect(() => {
    if (userRating) {
      setCurrentRating(userRating)
    }
  }, [userRating])

  return (
    <div className='row col-auto align-items-center'>
      <div className='col-sm-auto'>
        <span className='mc-text-h7'>
          {userRating
            ? t('article.subsections.recipe.ratingsCount', {
                ratingsCount: articleRatingsCount,
              })
            : t('article.subsections.recipe.rateNow', {
                ratingsCount: articleRatingsCount,
              })}
        </span>
      </div>
      <div className='col-auto'>
        {[...Array(stars)].map((_, index) => (
          <Rate
            key={`rate-${index}`}
            isActive={hoverCount ? index < hoverCount : index < currentRating}
            onClick={() => onClick(index + 1)}
            onMouseEnter={onMouseEnter(index)}
            onMouseLeave={onMouseLeave}
          />
        ))}
      </div>
    </div>
  )
}

export default Ratings
